import React from "react";
import { SectionTabs, type SectionTab } from "@cms/ui/components/section-tabs";

// The Media section's tabs: the Library (all uploaded files) and the photo
// Galleries built from it. Exact matches so the per-gallery editor
// (/media/galleries/:id) still lights the Galleries tab via its own href.
const MEDIA_TABS: SectionTab[] = [
  { label: "Library", href: "/media", end: true },
  { label: "Galleries", href: "/media/galleries" },
];

/**
 * The Media section's sticky tab header (Library / Galleries). Page actions
 * render beside the heading via PageHeader's `actions` slot, not here.
 */
export function MediaHeader() {
  return <SectionTabs sticky items={MEDIA_TABS} />;
}
